import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './styles.css';
import Select from 'react-select';

class SelectInput extends Component {
  render() {
    const { type, label, value, field, error } = this.props;
    return (
      <div className={error ? "form-group-select type__input__field error"  :"form-group-select type__input__field"}>
        <label 
          htmlFor={label} 
          className={value !== "" ? "select__input__label_hidden type__input__label" : "select__input__label type__input__label"}>
            {label}
          </label>
        <Select 
          options={this.props.options}
          onChange={this.props.handleSelect.bind(this, type, field)}
          placeholder={this.props.placeholder}
          isSearchable={false}
          value={value !== "" ? { label: value, value: value } : null}
      />
      </div>
    )
  }
};

SelectInput.propTypes = {
  options: PropTypes.array.isRequired,
  handleSelect: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired, 
  label: PropTypes.string.isRequired, 
  field: PropTypes.string.isRequired,
  value: PropTypes.string, 
  error: PropTypes.bool
}

export default SelectInput



// WEBPACK FOOTER //
// ./src/components/Select/Select.js